export default "__VITE_ASSET__BcUC$NiC__"